import { ModelEntityType } from '@upright/common/model/input/types';
import { EmptyStateStartManagingCompanyCTA } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/ctas/start-managing/start-managing-company';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { SingleEntityLensData } from '@upright/ui/common/upright/core/impact-lens-profile/types';

export function EmptyStateStartManagingCTA() {
  const context = useCarouselContext();
  const data = context.data as SingleEntityLensData<any>;

  if (data.entity?.type === ModelEntityType.COMPANY) {
    return <EmptyStateStartManagingCompanyCTA company={data.entity} />;
  }
  return <></>;
}
